import React from "react";
import { FormField } from "./";
import { ValidatedFormFieldBase } from "../validation";
// import { Icon } from "../generic";
// import ReactDOM from "react-dom";
// import { Utility } from "../../utils";

interface OwnProps {
    onInputChange?: (fieldName: string, value: string) => void;
}

interface OwnState {
}

export class DocumentUploadField extends ValidatedFormFieldBase<OwnProps, OwnState> {
    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        // const value = this.getValue(true);

        return <FormField {...this.props} errors={this.getErrors()} label={this.getLabel(this.props.label)} name={this.props.name} required={this.isRequired(this.props.required)}>

        </FormField>;
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/DocumentUploadField.tsx